module.exports = __webpack_public_path__ + "img/progress-3.62db03ee.svg";